import { inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "app.config";
import { AppState } from "app/shared/common/utils/AppState";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";
import { GraphQLService } from "app/shared/common/utils/graphql/graphql.service";
import { HttpHelper } from "app/shared/common/utils/http/HttpHelper";
import { AgGridWithoutCacheService } from "app/shared/components/base/ag-grid-without-cache/ag-grid-without-cache.service";
import { CAREER_PATH, CLASSIFICATION, HISTORY_ACT_LOG, INTERVIEW_STATUS, QUALIFICATION_TYPE, REQUEST_CANDIDATE_STATUS, REQUISITION_CANDIDATE_TASK_STATUS, SKILL_CATEGORY, STAKE_HOLDER, UNIT_CLASS, UNIT_TYPE } from "./workflow-task.constant";
import { ACT_LOG_ACTION } from "app/shared/common/utils/graphql/graphql.constant";
import { STATUS_IN_DATABASE } from "app/shared/common/constants/Status.constant";
import { RequisitionApi } from "app/shared/service/requisition/requisition.service";
import { map } from "rxjs";
import { GRAPHQL_QUERY } from "app/shared/common/utils/graphql/graphql.query.constant";
import { GRAPHQL_MUTATION } from "app/shared/common/utils/graphql/graphql.mutation.constant";

@Injectable({
  providedIn: "root",
})
export class WorkflowTaskService extends AgGridWithoutCacheService {
  readonly #requisitionApi: RequisitionApi = inject(RequisitionApi);

  constructor(
    private _httpHelper: HttpHelper,
    public _appState: AppState,
    private _graphQLService: GraphQLService
  ) {
    super(_httpHelper, _appState);
  }

  getWaitingAssignedTasks(rootCaseInstanceId: string): Promise<any> {
    const url = `${APP_CONFIG.XPTASK}task/getWaitingAssignedTasks?rootCaseInstanceId=${rootCaseInstanceId}`;
    return this._httpHelper.methodGetService(url);
  }

  getByTaskId(taskId: string): Promise<any> {
    const url = `${APP_CONFIG.XPTASK}task/getByTaskId?taskId=${taskId}`;
    return this._httpHelper.methodGetService(url);
  }

  getByProcInstId(procInstId: string): Promise<any> {
    const url = `${APP_CONFIG.XFLOW_ENGINE}procInst/getByProcInstId?procInstId=${procInstId}`;
    return this._httpHelper.methodGetService(url);
  }

  getTaskActions(taskId: string): Promise<any> {
    const url = `${APP_CONFIG.XPTASK}task/getTaskActions?taskId=${taskId}`;
    return this._httpHelper.methodGetService(url);
  }

  completeTask(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.XPTASK}task/complete`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  takeAction(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.XPTASK}task/takeAction`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  takeListActionTask(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}proc-inst/takeListActionTask`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  printNormalizedCV(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}candidate/printNormalizedCV`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  createSendOffer(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/createSendOffer`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  sendSurveyRequisition(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisition/sendSurveyRequisition`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateRequisitionJobQuantity(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionJob/updateRequisitionJobQuantity`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateRequisitionStakeHolderHandleBy(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionStakeHolder/updateRequisitionStakeHolderHandleBy`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateReqJobQuantityAndStakeHolder(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionJob/updateReqJobQuantityAndStakeHolder`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateSpecialErp(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisition/updateSpecialErp`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateListGoalAssignmentValue(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}goalAssignment/updateListGoalAssignmentValue`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  reupdateRequisitionRecruited(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionRecruited/reupdateRequisitionRecruited`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  sendInterviewEmail(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/sendInterviewEmail`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  sendInterviewEmailForCandidate(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/sendInterviewEmailForCandidate`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  sendInterviewEmailForInterviewer(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/sendInterviewEmailForInterviewer`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  getOfficeLocation(): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}calendarEvent/getOfficeLocation`;
    return this._httpHelper.methodGetService(url);
  }

  getAvailableRooms(officeLocation: string, startDate: any, endDate: any, zoneCode: any = "Asia/Bangkok"): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}calendarEvent/getAvailableRooms?officeLocation=${officeLocation}&startDate=${startDate}&endDate=${endDate}&zoneCode=${zoneCode}`;
    return this._httpHelper.methodGetService(url);
  }

  graphLogin(): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}graph/login`;
    return this._httpHelper.methodGetService(url);
  }

  graphReceiveTokens(data: { code: string }): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}graph/receiveTokens?code=${encodeURIComponent(data.code)}`;
    return this._httpHelper.methodGetService(url);
  }

  graphValidateToken(): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}graph/validateToken`;
    return this._httpHelper.methodGetService(url);
  }

  createMeeting(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}calendarEvent/createMeeting`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateMeeting(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}calendarEvent/update`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  sendOfferEmail(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/sendOfferEmail`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  scanCandidate(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/scanCandidate`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  transferCnB(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/transferCnB`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateTransferCnB(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/updateTransferCnB`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  printOffer(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/printOffer`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  printInterviews(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/printInterviews`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updatePendingRequisition(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisition/updatePendingRequisition`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  updateSupportChangeEmpType(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionJob/updateSupportChangeEmpType`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  createAssignment(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}assignment/create`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  cancelAssignment(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}assignment/cancel`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  completeMultiSubtask(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.XPTASK}task/completeMultiSubtask`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  rescheduleTimers(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.XPTASK}task/rescheduleTimers`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  getProcInstActLog(procInstId: string, fromTime: any, toTime: any, limit: number, offset: number, category: any, requisitionCandidateId: any = null): Promise<any> {
    const url =
      `${APP_CONFIG.XPACTSTREAMS}xflow/getProcInstActLog?procInstId=${procInstId}&offset=${offset}&limit=${limit}&fromTime=${fromTime}&toTime=${toTime}&category=${category}` +
      (requisitionCandidateId
        ? `&subCategory=${requisitionCandidateId}&scatMatchExactFlag=true`
        : ``);
    return this._httpHelper.methodGetService(url);
  }

  getWaitingTasks(procInstId: string): Promise<any> {
    const url = `${APP_CONFIG.XPTASK}task/getWaitingTasks?rootCaseInstanceId=${procInstId}`;
    return this._httpHelper.methodGetService(url);
  }

  getWaitingTasksRequisition(requisitionId: string): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}requisition/getWaitingTasks?requisitionId=${requisitionId}`;
    return this._httpHelper.methodGetService(url);
  }

  getWaitingTasksRequisitionCandidate(requisitionCandidateId: string): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/getWaitingTasks?requisitionCandidateId=${requisitionCandidateId}`;
    return this._httpHelper.methodGetService(url);
  }

  getInvolvedTaskKeys(rootCaseInstanceId): Promise<any> {
    const url = `${APP_CONFIG.XPTASK}task/getInvolvedTaskKeys?rootCaseInstanceId=${rootCaseInstanceId}`;
    return this._httpHelper.methodGetService(url);
  }

  getProcInstDataChangeAudit(procInstId: string, fromTime: any, toTime: any, limit: number, offset: number, category: string = HISTORY_ACT_LOG.HRM_RESOURCE_REQUEST): Promise<any> {
    const url = `${APP_CONFIG.XPACTSTREAMS}xflow/getProcInstDataChangeAudit?procInstId=${procInstId}&offset=${offset}&limit=${limit}&fromTime=${fromTime}&toTime=${toTime}&category=${category}`;
    return this._httpHelper.methodGetService(url);
  }

  getUserABBank(): Promise<any> {
    const request = {
      appCode: APP_CONFIG.APP_CODE,
      startRow: 0,
      endRow: 30,
      sortModel: [],
      filterModel: {
        userName: {
          type: "contains",
          filter: "@abbank.vn",
          filterType: "text",
        },
      },
    };
    const url = `${APP_CONFIG.XPSECMT}user/pivotPagingByApp`;
    return this._httpHelper.methodPostService(url, request);
  }

  pivotPagingUnit(value: any): Promise<any> {
    const filterModel: any = {
      "recordStatus": {
        "type": "equals",
        "filterType": "text",
        "filter": STATUS_IN_DATABASE.ACTIVE
      },
      "unitTypeCode": {
        "type": "equals",
        "filterType": "text",
        "filter": UNIT_TYPE.DEPT
      },
      "unitClassCode": {
        "type": "equals",
        "filterType": "text",
        "filter": UNIT_CLASS.DEPT
      }
    };

    // If value exists, add displayPath filter
    if (value) {
      filterModel["displayPath"] = {
        "type": "contains",
        "filterType": "text",
        "filter": value
      };
    }
    const request = {
      "startRow": 0,
      "endRow": 50,
      "sortModel": [
        // { "colId": "displayPath", "sort": "asc" }
      ],
      "filterModel": filterModel
    };
    const url = `${APP_CONFIG.MCRHRRCRT}requisition/pivotPagingUnit`;
    return this._httpHelper.methodPostService(url, request);
  }

  vStakeHolderDeptHeadPaging(requisitionDeptCode: any, startRow: number = 0, endRow: number = 5, filterModel: any = {}): Promise<any> {
    const request = {
      "startRow": startRow,
      "endRow": endRow,
      "rowGroupCols": [],
      "valueCols": [],
      "pivotCols": [],
      "pivotMode": false,
      "groupKeys": [],
      "filterModel": filterModel,
      "sortModel": []
    };
    // const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/pivotPagingStakeHolderDeptHead?requisitionDeptCode=${requisitionDeptCode}`;
    // Conditionally add query parameter only if requisitionDeptCode has a value
    const baseUrl = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/pivotPagingStakeHolderDeptHead`;
    const url = requisitionDeptCode ? `${baseUrl}?requisitionDeptCode=${requisitionDeptCode}` : baseUrl;
    return this._httpHelper.methodPostService(url, request);
  }

  // Recruitment
  getEmpInfoByEmpCode(empCode: any): Promise<any> {
    if (!empCode) {
      return new Promise((resolve) => {
        resolve(null);
      });
    }
    const where = { code: { _eq: empCode }, recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbEmployeeWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getEmpInfoByEmpId(empId: any, whereParam?: any): Promise<any> {
    const where = whereParam ? whereParam : { id: { _eq: empId }, recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbEmployeeWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getJobTitleByCode(code: any): Promise<any> {
    const where = { code: { _eq: code }, recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryTatmTitleWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getJobTitleById(id: any): Promise<any> {
    const where = { id: { _eq: id }, recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryTatmTitleWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryEmployeeInfo(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryHrtbEmployeeWithPositionWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where: where,
    });
  }

  getDepartmentByPath(path: any): Promise<any> {
    const where = { path: { _ancestor: path } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllCompany(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.CO } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllDepartment(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.DEPT } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getDepartmentByCode(code: string): Promise<any> {
    const where = { hrtm_unit_type: { code: { _eq: UNIT_TYPE.DEPT } }, code: { _eq: code } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getDepartmentById(id: string): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.DEPT } }, id: { _eq: id } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllJobFamilyByTrack(parentId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.FAMILY } }, parentId: { _eq: parentId } };
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllJobGroupByFamily(parentId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.GROUP } }, parentId: { _eq: parentId } };
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllJobSubGroupByGroup(parentId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.SUBGROUP } }, parentId: { _eq: parentId } };
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  quickSearchEmployee(keyword: string, employeeStatus: string = "ACTIVE"): Promise<any> {
    const keywordEmail = keyword + '%'
    const keywordName = ('%' + keyword + '%');
    let where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, _or: [{ email: { _like: keywordEmail } }, { name: { _cast: { String: { _ilike: keywordName } } } }] };
    if (employeeStatus) {
      where['employeeStatus'] = { _eq: employeeStatus };
    }
    const limit = 20;
    const offset = 0;
    const query = GRAPHQL_QUERY.hrmQueryHrtbEmployeeWithLimitOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
      limit,
      offset
    });
  }

  quickSearchDepartment(keyword: string): Promise<any> {
    keyword = ('%' + keyword + '%');
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.DEPT } }, hrtm_unit_class: { code: { _eq: UNIT_CLASS.DEPT } }, displayPath: { _ilike: keyword } };
    const limit = 20;
    const offset = 0;
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWithLimitOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
      limit,
      offset
    });
  }

  quickSearchRequestForRole(keyword: string): Promise<any> {
    keyword = ('%' + keyword + '%');
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, name: { _cast: { String: { _ilike: keyword } } } };
    const limit = 20;
    const offset = 0;
    const query = GRAPHQL_QUERY.hrmQueryTatmTitleWithLimitOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
      limit,
      offset
    });
  }

  getAllRequisitionCandidateWhere(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWithWorkerWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where: where,
    });
  }

  getEmployeeByEmails(emails: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, email: { _in: emails } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbEmployeeWithJobWorkerWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllMasterBookingInterview(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryMasterDataBookingInterviewWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where: where,
      where1: where
    });
  }

  async getAllMasterDataRequest(): Promise<any> {
    const cached = this._appState.cachedMasterDataRequest;
    if (cached) {
      return Promise.resolve(cached);
    }

    const resultCompany = await this.getAllMasterDataRequestWithCompany();
    const resultJob = await this.getAllMasterDataRequestWithJob();
    const result = { ...resultCompany, ...resultJob };
    this._appState.cachedMasterDataRequest = result;
    return result;
  }

  getAllMasterDataRequestWithCompany(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const whereCompany = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.CO } } };
    const query = GRAPHQL_QUERY.hrmQueryMasterDataRequestWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1: where, where2: whereCompany, where3: where, where4: where, where5: where
    });
  }

  getAllMasterDataRequestWithJob(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, isDegree: { _eq: true }, tatm_qualification_type: { code: { _eq: QUALIFICATION_TYPE.EDU } } }
    const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, isPersonalLevelFlg: { _eq: CAREER_PATH.PERSONAL_LEVEL } }
    const where2 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.FAMILY } } }
    const where3 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where4 = where3;
    const where5 = { stakeHolderCode: { _in: [STAKE_HOLDER.RECRUITER, STAKE_HOLDER.RECRUITERBU] } }
    const query = GRAPHQL_QUERY.hrmQueryMasterDataRequestWithJobWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1, where2, where3, where4, where5
    });
  }

  getAllHandledBy(): Promise<any> {
    const where = { stakeHolderCode: { _in: [STAKE_HOLDER.RECRUITER, STAKE_HOLDER.RECRUITERBU] } };
    const query = GRAPHQL_QUERY.hrmQueryViewStakeHolderDeptHeadWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  async getAllMasterDataUpdateGoal(teamAssignmentId: any): Promise<any> {
    // const cached = this._appState.cachedKstbGoal[teamAssignmentId];
    // if (cached) {
    //   return Promise.resolve(cached);
    // }

    const resultGoal = await this.getKstbGoalWhere(teamAssignmentId);
    if (!this._appState.cachedMasterDataGoal) {
      const resultMasterData = await this.getMasterDataUpdateGoal();
      if (UtilCommon.isNotNull(resultMasterData)) {
        this._appState.cachedMasterDataGoal = { ...resultMasterData };
      }
    }
    const result = { ...resultGoal, ...this._appState.cachedMasterDataGoal };
    this._appState.cachedKstbGoal[teamAssignmentId] = result;
    return result;
  }

  getKstbGoalWhere(teamAssignmentId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, kstb_goal_assignments: { id: { _eq: teamAssignmentId } } };
    const query = GRAPHQL_QUERY.hrmQueryKstbGoalWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getMasterDataUpdateGoal(): Promise<any> {
    const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
    const where2 = where1;
    const where3 = { stakeHolderCode: { _in: [STAKE_HOLDER.RECRUITER, STAKE_HOLDER.RECRUITERBU] } };
    const query = GRAPHQL_QUERY.hrmQueryMasterDataGoalWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where1, where2, where3
    });
  }

  getAllMasterDataUpdateSpecialERP(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryRstmReferralProgramWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  async getAllMasterDataOffer(): Promise<any> {
    const cached = this._appState.cachedMasterDataOffer;
    if (cached) {
      return Promise.resolve(cached);
    }

    const resultOffer = await this.getAllMasterDataOfferWithOffice();
    const resultOfferWithJob = await this.getAllMasterDataOfferWithJob();
    const result = { ...resultOffer, ...resultOfferWithJob };
    this._appState.cachedMasterDataOffer = result;
    return result;
  }

  getAllMasterDataOfferWithOffice(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where1 = where;
    const where2 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.COGRP } } }
    const where3 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.CO } } }
    const where4 = where;
    const where5 = where;
    const query = GRAPHQL_QUERY.hrmQueryMasterDataOfferWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1, where2, where3, where4, where5
    });
  }

  getAllMasterDataOfferWithJob(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where1 = where;
    const where2 = where;
    const where3 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, isPersonalLevelFlg: { _eq: CAREER_PATH.CAREER_PATH } }
    const where4 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.FAMILY } } };
    const query = GRAPHQL_QUERY.hrmQueryMasterDataOfferWithJobWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1, where2, where3, where4
    });
  }

  getAllMasterDataAcceptOffer(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryMasterDataAcceptOfferWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where: where, where1: where, where2: where
    });
  }

  getAllMasterDataAssignment(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryHrtmAttachmentTypeWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  async getAllSkill(): Promise<any> {
    const cached = this._appState.cachedAllSkill;
    if (cached) {
      return Promise.resolve(cached);
    }

    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryTatmSkillWithCategoryWhere.query;
    const result = await this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
    this._appState.cachedAllSkill = result;
    return result;
  }

  quickSearchSkill(keyword: string): Promise<any> {
    keyword = ('%' + keyword + '%');
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_skill_category: { code: { _eq: SKILL_CATEGORY.SKILL } }, name: { _cast: { String: { _ilike: keyword } } } };
    const limit = 20;
    const offset = 0;
    const query = GRAPHQL_QUERY.hrmQueryTatmSkillWithCategoryLimitOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
      limit,
      offset
    });
  }

  getCandidateContactEmail(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryViewCurrentCandidateEmailWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getCandidateIdentityForAcceptOffer(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateForIdentityAcceptOfferWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryLocality(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryPltmLocalityWithCountryTypeWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryEthnic(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryHrtmEthnicityWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
    });
  }

  quickSearchLocality(where: any): Promise<any> {
    const limit = 20;
    const offset = 0;
    const query = GRAPHQL_QUERY.hrmQueryPltmLocalityWithCountryTypeLimitOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
      limit,
      offset
    });
  }

  quickSearchIssuingAuthorities(where: any): Promise<any> {
    const limit = 20;
    const offset = 0;
    const query = GRAPHQL_QUERY.hrmQueryPltmIssuingAuthoritiesLimitOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
      limit,
      offset
    });
  }

  deleteWorkerAddress(_eq: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_CANDIDATE_RR);
    const mutation = GRAPHQL_MUTATION.hrmDeleteHrtbWorkerAddressById.query
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq
    });
  }

  deleteWorkerLegalDoc(_eq: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_CANDIDATE_RR);
    const mutation = GRAPHQL_MUTATION.hrmDeleteHrtbWorkerLegaldoc.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq
    });
  }

  deleteWorkerAttachment(_in: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_CANDIDATE_RR);
    const mutation = GRAPHQL_MUTATION.hrmDeleteHrtbWorkerAttachmentByIds.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in
    });
  }

  updateCandidateIdentity(_eq: any, _set: any, _eq1: any, _setCandidate: any, objectLegalDoc: any, objectAttachments: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_CANDIDATE_RR);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    objectLegalDoc = {
      ...objectLegalDoc,
      ...this._graphQLService.getDefaultMutationObject(),
    };
    if (UtilCommon.isArray(objectAttachments, true)) {
      objectAttachments = objectAttachments.map((obj) => ({
        ...obj, // Spread the existing user properties
        ...this._graphQLService.getDefaultMutationObject(), // Spread the properties from updateObj
      }));
    }
    const mutation = GRAPHQL_MUTATION.hrmUpdateCandidateIdentity.query
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _set,
      _eq1,
      _setCandidate,
      objectLegalDoc,
      objectAttachments,
    });
  }

  getTeamByParentId(parentId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, parentId: { _eq: parentId }, hrtm_unit_type: { code: { _eq: UNIT_TYPE.DEPT } }, hrtm_unit_class: { code: { _eq: UNIT_CLASS.TEAM } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllRequestType(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
    const query = GRAPHQL_QUERY.hrmQueryRstmReqTypeWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  // api not used
  getRequisitionById(id: any): Promise<any> {
    const where = { id: { _eq: id } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  async getDetailRequisitionById(id: any): Promise<any> {
    const resultDetail = await this.queryRstbRequisitionForDetail(id);
    const resultDetailWithRequisitionCandidate = await this.queryRstbRequisitionForDetailWithRequisitionCandidate(id);
    const resultDetailWithRr = await this.queryRstbRequisitionForDetailWithRRWhere();
    if (!this._appState.cachedRRM) {
      this._appState.cachedRRM = { ...resultDetailWithRr };
    }
    const result = { ...(resultDetail || {}), ...(resultDetailWithRequisitionCandidate || {}), ...(resultDetailWithRr || {}) };
    return result;
  }

  queryRstbRequisitionForDetail(id: any): Promise<any> {
    // const where = { id: { _eq: id } };
    const _eq = id;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForDetailWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq
    });
  }

  queryRstbRequisitionForDetailWithRequisitionCandidate(id: any): Promise<any> {
    // const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, requisitionId: { _eq: id } };
    // const where1 = { requisition_id: { _eq: id } };
    const _eq = STATUS_IN_DATABASE.ACTIVE;
    const _eq1 = id;
    const _eq2 = id;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForDetailWithRequisitionCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq, _eq1, _eq2
    });
  }

  queryRstbRequisitionForDetailWithRRWhere(): Promise<any> {
    if (this._appState.cachedRRM) {
      return Promise.resolve(this._appState.cachedRRM);
    }
    const where1 = { stakeHolderCode: { _eq: STAKE_HOLDER.RRM } }
    const where2 = { stakeHolderCode: { _eq: STAKE_HOLDER.RRBU } }
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForDetailWithRRWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where1, where2
    });
  }

  queryRecommenderFofOffer(candidateId: any, extRequestCode: string): Promise<any> {
    const where = { hrtb_candidate_resume: { candidateId: { _eq: candidateId }, extRequestCode: { _eq: extRequestCode } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateRecommenderWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRecommenderFofMatchingCheckExeclutive(candidateIds: any, extRequestCode: string): Promise<any> {
    const where = { hrtb_candidate_resume: { candidateId: { _in: candidateIds }, extRequestCode: { _eq: extRequestCode } } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateRecommenderWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionDelaySurvey(requisitionId): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, id: { _eq: requisitionId } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryOdooApprovalHistory(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbOdooApprovalHistoryWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryOdooJobApprovalHistory(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbOdooJobApprovalHistoryWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionOfferByReqId(reqCandidateId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, reqCandidateId: { _eq: reqCandidateId } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionOfferDraftByReqId(reqCandidateId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, reqCandidateId: { _eq: reqCandidateId } };
    const query = GRAPHQL_QUERY.hrmQueryRstdRequisitionOffsetWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionCandidatesByReqId(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionCandidates(requisitionId, candidateIds): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, requisitionId: { _eq: requisitionId }, candidateId: { _in: candidateIds } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionCandidate(requisitionId, candidateId): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, requisitionId: { _eq: requisitionId }, candidateId: { _eq: candidateId } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionCandidatesByIds(ids): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, id: { _in: ids }, taskStatus: { _neq: REQUISITION_CANDIDATE_TASK_STATUS.PROCESSING } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryCheckCandidateDoneInRequisition(requisitionId: any): Promise<any> {
    // const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, requisitionId: { _eq: requisitionId } };
    // const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, id: { _eq: requisitionId } }
    const _eq = STATUS_IN_DATABASE.ACTIVE;
    const _eq1 = requisitionId;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateForValidTransferWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq, _eq1
    });
  }

  queryCandidateGroupForValidTransfer(workerIds: any): Promise<any> {
    const _in = workerIds;
    const recordStatus = STATUS_IN_DATABASE.ACTIVE;
    const query = GRAPHQL_QUERY.hrmQueryCandidateGroupForValidTransfer.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _in, recordStatus
    });
  }

  queryCheckCandidateRequisition(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateForCheckWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryCheckQuantityOfferDoneCandidateInRequisition(requisitionId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, id: { _eq: requisitionId } };
    const where1 = {
      recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE },
      status: { _in: [REQUEST_CANDIDATE_STATUS.OFFER, REQUEST_CANDIDATE_STATUS.DONE] },
      requisitionId: { _eq: requisitionId }
    };
    const where2 = {
      recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE },
      status: { _nin: [REQUEST_CANDIDATE_STATUS.OFFER, REQUEST_CANDIDATE_STATUS.DONE, REQUEST_CANDIDATE_STATUS.CLOSE, REQUEST_CANDIDATE_STATUS.FAIL, REQUEST_CANDIDATE_STATUS.CANCEL, REQUEST_CANDIDATE_STATUS.CANCEL_ONBOARDING] },
      requisitionId: { _eq: requisitionId }
    };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForCountDoneCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1, where2
    });
  }

  queryDetailHrtbCandidates(candidateIds): Promise<any> {
    const where = { id: { _in: candidateIds } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  matchCandidate(_in, status, objectCandidates, objectAttachments): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    // _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    if (UtilCommon.isArray(objectCandidates, true)) {
      objectCandidates = objectCandidates.map((obj) => ({
        ...obj, // Spread the existing user properties
        ...this._graphQLService.getDefaultMutationObject(), // Spread the properties from updateObj
      }));
    }
    if (UtilCommon.isArray(objectAttachments, true)) {
      objectAttachments = objectAttachments.map((obj) => ({
        ...obj, // Spread the existing user properties
        ...this._graphQLService.getDefaultMutationObject(), // Spread the properties from updateObj
      }));
    }

    const mutation = GRAPHQL_MUTATION.hrmInsertRstbRequisitionCandidateForMatching.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in, status,
      objectCandidates: objectCandidates,
      objectAttachments: objectAttachments
    });
  }

  queryCandidateAttachment(whereCandidate, whereAttachment): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateWithWorkerAttachmentWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where: whereCandidate,
      where1: whereAttachment,
    });
  }

  updateHrmCandidate(_eq: number, _set: Object) {
    const mutation = GRAPHQL_MUTATION.hrmUpdateHrtbCandidateById.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _set
    });
  }

  // api not used
  updateRequisitionDelayNote(requisitionId: any, delayNote: string = ""): Promise<any> {
    const _set = {
      delayNote: delayNote,
      updateId: this.appState.getAppStateUsername(),
      updateDate: UtilCommon.genDateNow(),
    };
    const query = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionById.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq: requisitionId,
      _set
    });
  }

  // api not used
  updateRequisitionRecordSurvey(requisitionId: any, surveyFlg: number = 0, reasonNotSurvey: string = ""): Promise<any> {
    const _set = {
      surveyFlg: surveyFlg,
      reasonNotSurvey: reasonNotSurvey,
      updateId: this.appState.getAppStateUsername(),
      updateDate: UtilCommon.genDateNow(),
    };
    const query = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionById.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq: requisitionId,
      _set
    });
  }

  startCandidateProcess(request: any): Promise<any> {
    const url = `${APP_CONFIG.MCRHRRCRT}proc-inst/start`;
    const params = `${JSON.stringify(request)}`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  startTaskComplete(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}proc-inst/startTaskComplete`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  sendToHRMConfirmEmail(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/sendToHRMConfirmEmail`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  getDeptHeadHRBP(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryHrtbUnitWithDeptHeadHRBPWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryRequisitionCandidateInterview(requisitionCandidateId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, requisitionCandidateId: { _eq: requisitionCandidateId } }
    const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
    const query = GRAPHQL_QUERY.hrmQueryRstbInterviewWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1
    });
  }

  queryInterviewStatusBooking(requisitionCandidateId: any): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, status: { _eq: INTERVIEW_STATUS.PASS }, requisitionCandidateId: { _eq: requisitionCandidateId } };
    const query = GRAPHQL_QUERY.hrmQueryRstbInterviewJustStatusWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  insertInterview(objects: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    objects = { ...objects, ...this._graphQLService.getDefaultMutationObject() };
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbInterview.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  updateBookingInterview(_eq: number, _setInterview: any, objectInterviewers: any[]): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _setInterview = {
      ..._setInterview,
      ...this._graphQLService.getDefaultMutationObject(false),
    };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbInterviewForBooking.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _setInterview,
      objectInterviewers
    });
  }

  updateInterview(_eq: number, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbInterview.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _set
    });
  }

  updateAssessmentInterview(_eq: number, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbAssessmentInterview.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _set
    });
  }

  insertOffer(objects: any): Promise<void> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    objects = { ...objects, ...this._graphQLService.getDefaultMutationObject() };
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbRequisitionOffer.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects,
    });
  }

  updateOffer(_eq: any, _set: any): Promise<void> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionOffer.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _set
    });
  }

  insertOfferDraft(objects: any): Promise<void> {
    objects = { ...objects, ...this._graphQLService.getDefaultMutationObject() };
    const mutation = GRAPHQL_MUTATION.hrmInsertRstdRequisitionOffer.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  updateOfferDraft(_eq: number, _set: any): Promise<void> {
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstdRequisitionOffer.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq, _set
    });
  }

  queryCandidateForReqCandidate(candidateId: any, requisitionCandidateId): Promise<any> {
    // const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, id: { _eq: candidateId } };
    // const where1 = { id: { _eq: requisitionCandidateId } }
    const _eq1 = candidateId;
    const _eq2 = STATUS_IN_DATABASE.ACTIVE;
    const _eq = requisitionCandidateId;
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateForDetailMatchingWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq1, _eq2, _eq
    });
  }

  queryPostingByRefNo(requisitionAggId): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, postingRefno: { _eq: requisitionAggId } };
    const query = GRAPHQL_QUERY.hrmQueryCstbPostingWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  insertRequisitionApproval(objects: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    if (UtilCommon.isArray(objects, true)) {
      objects = objects.map((obj) => ({
        ...obj, // Spread the existing user properties
        ...this._graphQLService.getDefaultMutationObject(), // Spread the properties from updateObj
      }));
    }
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbRequisitionApproval.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  getReasonByType(typeCode: string): Promise<any> {
    const where = { rstb_reason: { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }, rstm_reason_type: { code: { _eq: typeCode } } };
    const query = GRAPHQL_QUERY.hrmQueryRstbReasonDeploymentWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAllReason(): Promise<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryRstbReasonWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getGoalMasterData(): Promise<any> {
    const where = { rstm_stake_holder: { code: { _in: [STAKE_HOLDER.RECRUITER, STAKE_HOLDER.RECRUITERBU] } } };
    const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } }
    const where2 = where1
    const query = GRAPHQL_QUERY.hrmQueryMasterDataGoalForInsertWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where, where1, where2
    });
  }

  insertGoal(objects: any): Promise<any> {
    const mutation = GRAPHQL_MUTATION.hrmInsertKstbGoal.query
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  updateGoal(objects: any): Promise<any> {
    const mutationPromises: Promise<any>[] = [];
    const insertKstbGoalForUpdate = GRAPHQL_MUTATION.hrmInsertKstbGoalForUpdate.query
    mutationPromises.push(this._graphQLService.mutatePromiseWithVariable(insertKstbGoalForUpdate, {
      objects1: objects.insertEmpGoalList,
      objects2: objects.insertAssignmentList,
      objects3: objects.insertHistoryList
    }));
    if (UtilCommon.isArray(objects.updateGoalList, true)) {
      mutationPromises.push(
        ...objects.updateGoalList.map((item) => {
          const updateKstbGoal = GRAPHQL_MUTATION.hrmUpdateKstbGoal.query;
          return this._graphQLService.mutatePromiseWithVariable(updateKstbGoal, { _eq: item.id, _set: item.data });
        })
      );
    }
    if (UtilCommon.isArray(objects.updateAssignmentList, true)) {
      mutationPromises.push(
        ...objects.updateAssignmentList.map((item) => {
          const updateKstbGoalAssignment = GRAPHQL_MUTATION.hrmUpdateKstbGoalAssignment.query;
          return this._graphQLService.mutatePromiseWithVariable(updateKstbGoalAssignment, { _eq: item.id, _set: item.data });
        })
      );
    }
    return Promise.all(mutationPromises);
  }

  reopenCandidateNotStart(_in: any, _set: any, _in1: any, _set1: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    _set1 = {
      ..._set1,
      ...this._graphQLService.getDefaultMutationObject(false),
    };
    const mutation = GRAPHQL_MUTATION.hrmUpdateReopenCandidateNotStart.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in,
      _set,
      _in1,
      _set1,
    });
  }

  updateRecruitRequisitionCandidate(_eq: number, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionCandidate.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq, _set
    });
  }

  updateRecruitRequisitionCandidateByTaskId(_eq: string, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionCandidateByTaskId.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq, _set
    });
  }

  updateRecruitRequisitionCandidateByIds(_in: any, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionCandidateByIds.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in, _set
    });
  }

  updateRecruitRequisitionCandidateByTaskIds(_in: any, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionCandidateByTaskIds.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in, _set
    });
  }

  updateRequisition(_eq: number, _set: any): Promise<any> {
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const query = GRAPHQL_MUTATION.hrmUpdateRstbRequisitionById.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      _eq, _set
    });
  }

  insertRRScreeningAssessment(objects: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    objects = { ...objects, ...this._graphQLService.getDefaultMutationObject() };
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbAssessmentScreening.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  updateRRScreeningAssessment(_eq: number, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbAssessmentScreening.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq,
      _set
    });
  }

  queryRRScreeningAssessment(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbAssessmentScreeningWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryCandidateAssignment(where: any): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbAssignmentWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  insertAssignment(objects: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    objects = { ...objects, ...this._graphQLService.getDefaultMutationObject() };
    // const mutation = `
    //   mutation XHuntMutationInsertAssignment($objects: [recruit_rstb_assignment_insert_input!] = {}) {
    //     data: insert_recruit_rstb_assignment(objects: $objects) {
    //       returning {
    //         aggId
    //       }
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbAssignment.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  updateAssignment(_eq: number, _set: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    _set = { ..._set, ...this._graphQLService.getDefaultMutationObject(false) };
    // const mutation = `
    //   mutation XHuntMutationUpdateAssignment($where: recruit_rstb_assignment_bool_exp = {}, $_set: recruit_rstb_assignment_set_input = {}) {
    //     update_recruit_rstb_assignment(where: $where, _set: $_set) {
    //       affected_rows
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmUpdateRstbAssignment.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq, _set
    });
  }

  deleteAssignment(_eq: number): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    // const mutation = `
    //   mutation XHuntMutationDeleteAssignment($where: recruit_rstb_assignment_bool_exp = {}) {
    //     delete_recruit_rstb_assignment(where: $where) {
    //       affected_rows
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmDeleteRstbAssignment.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _eq
    });
  }

  insertAssignmentAttachment(objects: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    if (UtilCommon.isArray(objects, true)) {
      objects = objects.map((obj) => ({
        ...obj, // Spread the existing user properties
        ...this._graphQLService.getDefaultMutationObject(), // Spread the properties from updateObj
      }));
    }
    // const mutation = `
    //   mutation XHuntMutationInsertAssignmentAttachment($objects: [recruit_rstb_assignment_attachment_insert_input!] = {}) {
    //     insert_recruit_rstb_assignment_attachment(objects: $objects) {
    //       affected_rows
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbAssignmentAttachment.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  deleteAssignmentAttachment(_in: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    // const mutation = `
    //   mutation XHuntMutationDeleteAssignmentAttachment($where: recruit_rstb_assignment_attachment_bool_exp = {}) {
    //     delete_recruit_rstb_assignment_attachment(where: $where) {
    //       affected_rows
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmDeleteRstbAssignmentAttachment.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in
    });
  }

  translatehtml(data: any): Promise<any> {
    if (data?.text) {
      data.text = UtilCommon.sanitizeHtml(data.text);
    }
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.XFAI}translator/translatehtml`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  queryActLogMatchCandidateProcess(requisitionCandidateId: any): Promise<any> {
    const where = { id: { _eq: requisitionCandidateId } };
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateActLogWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryActLogCandidateRR(candidateId: any): Promise<any> {
    const where = { id: { _eq: candidateId } };
    const query = GRAPHQL_QUERY.hrmQueryHrtbCandidateActLogWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  queryActLogStudentProgram(eventParticipantId: any): Promise<any> {
    const where = { id: { _eq: eventParticipantId } };
    const query = GRAPHQL_QUERY.hrmQueryPstbEventParticipantActLogWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }

  getAuditLogChange(data: any): Promise<any> {
    // select * from actlog.f_get_log_change('MATCH_CANDIDATE', 'rstb_requisition_candidate-486,487;hrtb_candidate-2131','INSERT,UPDATE');
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}actlog/getAuditLogChange`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  queryTracking(where: any): Promise<any> {
    // UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    // _setInterview = { ..._setInterview, ...this._graphQLService.getDefaultMutationObject(false) };
    const query = GRAPHQL_QUERY.hrmQueryRstbTrackingWhere.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      where,
    });
  }

  deleteTracking(_in: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    // const mutation = `
    //   mutation XHuntMutationDeleteTracking($where: recruit_rstb_tracking_bool_exp = {}) {
    //     delete_recruit_rstb_tracking(where: $where) {
    //       affected_rows
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmDeleteRstbTracking.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      _in
    });
  }

  insertTracking(objects: any): Promise<any> {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_MATCH_CANDIDATE_PROCESS);
    objects = objects.map((obj) => ({
      ...obj, // Spread the existing user properties
      ...this._graphQLService.getDefaultMutationObject(), // Spread the properties from updateObj
    }));
    // const mutation = `
    //   mutation XHuntMutationInsertTracking($objects: [recruit_rstb_tracking_insert_input!] = []) {
    //     insert_recruit_rstb_tracking(objects: $objects) {
    //       affected_rows
    //     }
    //   }
    // `;
    const mutation = GRAPHQL_MUTATION.hrmInsertRstbTracking.query;
    return this._graphQLService.mutatePromiseWithVariable(mutation, {
      objects
    });
  }

  loadReferenceCheckRecruit(candidateId) {
    const whereClause = {
      recordStatus: {
        _eq: STATUS_IN_DATABASE.ACTIVE,
      },
      rstb_requisition_candidate: {
        candidateId: { _eq: candidateId },
      },
    };
    return this.#requisitionApi.getRerferenceCheck(whereClause).pipe(
      map((value) =>
        value.map((item) => {
          return {
            ...item,
            requestCode: item?.requisitionCandidate?.requisition?.code,
          };
        })
      )
    );
  }

  loadDataSummary(requisitionCandidateId: string) {
    const url = `${APP_CONFIG.MCRHRRCRT}candidate/getRequisitionCandidateCV?requisitionCandidateId=${requisitionCandidateId}`;
    return this.httpHelper.methodGetObservableService(url);
  }

  queryAllDisplayStatus(): Promise<any> {
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionCandidateAllDisplayStatus.query;
    return this._graphQLService.mutatePromiseWithVariable(query, {
      distinct_on: ['displayStatus'],
    });
  }

  getTAHandleByRRInCharge(reqCandidateId: any): Promise<any> {
    const userInfo = this._appState.getAppState();
    const data = {
      "reqCandidateId": reqCandidateId,
      "tenantCode": userInfo?.moreInfo?.tenantCode,
      "appCode": userInfo?.moreInfo?.appCode
    }
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/getTAHandleByRRInCharge`;
    return this._httpHelper.methodPostJsonService(url, params);
  }

  cancelInterviewSetting(data: any): Promise<any> {
    const params = `${JSON.stringify(data)}`;
    const url = `${APP_CONFIG.MCRHRRCRT}requisitionCandidate/cancelInterviewSetting`;
    return this._httpHelper.methodPostJsonService(url, params);
  }
}
